import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HeaderStatus } from '../models/header-status.model';
import { Company } from '../models/company.model';
import { SignatureRequestService } from './signature-request.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class SignaturesHeaderService {

  private currentHeaderStatusSubject: BehaviorSubject<HeaderStatus> = new BehaviorSubject({
    opened: false,
    bold_text:null,
    text:null,
    svg:null,
  } as HeaderStatus);
  public currentHeaderStatus: Observable<HeaderStatus> = this.currentHeaderStatusSubject.asObservable();

  // Signature process
  private loadingBarStepSubject = new BehaviorSubject<0|1|2|3>(0);
  loadingBarStep = this.loadingBarStepSubject.asObservable();

  private company:Company = null as any;

  constructor(private signature_request:SignatureRequestService,
              private utils:UtilsService) {
    this.listenCompany();
  }

  closeHeader() {
    this.currentHeaderStatusSubject.next({
      opened: false,
      bold_text: null,
      text: null,
      svg: null
    });
  }

  openHeader(bold_text:string, text:string, svg:string) {
    if(this.company!=null && this.company.color!=null) {
      svg = svg.replaceAll('#c2e7bb', this.utils.lighterColor(this.company.color)); // lighter
      svg = svg.replaceAll('#4fa770', this.company.color); // primary
    }

    this.currentHeaderStatusSubject.next({
      opened: true,
      bold_text: bold_text,
      text: text,
      svg: svg
    });
  }

  setAuthStep(step:0|1|2|3) {
    this.loadingBarStepSubject.next(step);
  }

  reset() {
    this.loadingBarStepSubject.next(0);
    this.currentHeaderStatusSubject.next({
      opened: false,
      bold_text:null,
      text:null,
      svg:null
    });
  }

  private listenCompany() {
    this.signature_request.company.subscribe(
      data => {
        this.setCompany(data);
      }
    );
  }

  private setCompany(data:Company) {
    this.company = data;
    this.reloadColorsHeader();
  }

  private reloadColorsHeader() {
    const currentHeaderStatus = this.currentHeaderStatusSubject.value;
    if(currentHeaderStatus.opened && currentHeaderStatus.svg!=null && currentHeaderStatus.svg.toString().indexOf("#c2e7bb")!==-1) {
      this.openHeader(currentHeaderStatus.bold_text as string, currentHeaderStatus.text as string, currentHeaderStatus.svg.toString());
    }
  }

}
